<div class="row justify-content-between">
     <div class="col-12 col-sm-6 searchEdit mb-3">
       <label for="searchEdit" class="sr-only">Records search</label>
       <input 
         [(ngModel)]="searchCriteria.searchString"
         type="text" 
         id="searchEdit"
         class="form-control form-control-search" 
         [placeholder]="'DashboardSearchInput' | translator: 'customer'" 
         [title]="'DashboardSearchInput' | translator: 'customer'" 
         (keyup)="emit(keyword.value);" #keyword
       />
     </div>
     <div class="col-auto d-flex align-items-center text-right mb-3">
       <label 
         for="pageSize" 
         class="form-label mb-0 me-2"
         [innerHTML]="'View' | translator: 'driver'"
         [title]="'View' | translator: 'driver'"
       >View</label>
       <select 
         [(ngModel)]="searchCriteria.pageSize"
         (change)="onPageSizeChanged(pageSize.value)" 
         id="pageSize"
         name="pageSize"
         class="form-select"
         #pageSize
       >
         <option value="10" selected>10</option>
         <option value="25">25</option>
         <option value="50">50</option>
         <option value="100">100</option>
         <option value="250">250</option>
       </select>
     </div>
</div>